(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('gbEditModalCtrl', [
        '$rootScope',
        '$scope',
        '$uibModalInstance',
        'SourceConstant',
        'AppConstants',
        'BrowserService',
        'localStorageService',
        'documentName',
        'documentId',
        gbEditModalController
    ]);

    function gbEditModalController($rootScope, $scope, $uibModalInstance, SourceConstant, AppConstants, BrowserService, localStorageService, documentName, documentId) {

        var os = BrowserService.getOS(),
            OSTypes = AppConstants.OSTypes;

        $scope.documentName = documentName;
        $scope.documentId = documentId;
        $scope.heading = 'MODAL.LAUNCH_APP.LAUNCHING_APP';
        $scope.message1 = 'MODAL.LAUNCH_APP.SYNC_CLIENT_INTRO';
        $scope.message2 = 'MODAL.LAUNCH_APP.SYNC_CLIENT_NEEDED';
        //Always change the dummyParam to avoid cloudfront caching it
        $scope.clientIcon = 'images/workdocs_edit_img.png?dummyParam=2';
        $scope.clientDownloadUrl = AppConstants.ClientDownloadUrl.ALL;
        $scope.downloadIcon = null;

        if (os === OSTypes.MAC) {
            $scope.downloadIcon = 'images/mac.png';
            $scope.clientDownloadUrl = AppConstants.ClientDownloadUrl.MAC;
        } else if (os === OSTypes.WINDOWS) {
            $scope.downloadIcon = 'images/pc.png';
            $scope.clientDownloadUrl = AppConstants.ClientDownloadUrl.WINDOWS;
        }

        $scope.closeModal = function() {
            $uibModalInstance.close();

            var dontShowAgainCheckbox = $('#dontShowCheckbox:checked'),
                dontShowAgainChecked = dontShowAgainCheckbox && dontShowAgainCheckbox.length > 0;

            if (dontShowAgainChecked) {
                localStorageService.set('DO_NOT_SHOW_LAUNCH_MODAL', true);
            }
        };

    }
}());
